import React from 'react'
import { FaCertificate, FaExchangeAlt, FaCheckCircle, FaChartLine, FaMapMarkerAlt, FaPhone, FaGlobe, FaArrowRight, FaExternalLinkAlt } from 'react-icons/fa'
import './About.css'

const Aboutus = () => {
    return (
        <div className='trillion-about-section'>
            <div className="trillion-about-container">
                <div className="trillion-about-header">
                    <span className="trillion-about-subtitle">ABOUT US</span>
                    <h2 className="trillion-about-title">Unlock the Next Stage of Success</h2>
                    <div className="trillion-about-divider"></div>
                </div>

                <div className="trillion-about-content">
                    <div className="trillion-about-main">
                        <div className="trillion-about-intro-wrapper">
                            <div className="trillion-about-intro-content">
                                <p className="trillion-about-intro">
                                    We are dedicated to empowering investors with the knowledge and tools necessary to navigate the complexities of the financial markets. Our mission is to provide in-depth research, insightful analysis, and actionable strategies that enable our clients to make informed investment decisions.
                                </p>
                            </div>
                        </div>

                        <div className="trillion-about-description-wrapper">
                            <div className="trillion-about-description-content">
                                <p className="trillion-about-description">
                                    Trillion Stock Research is a SEBI-registered investment advisory firm (SEBI Registration No: INH000020129) committed to providing professional stock market research, trading strategies, and investment insights. Based in Indore, we help traders and investors navigate the financial markets with confidence through our in-depth analysis and personalized guidance.
                                </p>
                                <div className="trillion-about-certification">
                                    <FaCertificate />
                                    <span>SEBI Registered Research Analyst</span>
                                </div>
                                <div className="trillion-about-certification" style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                    <FaExchangeAlt />
                                    <span>BSE Enlistment No.: 6528</span>
                                </div>
                                <div className="trillion-about-certification" style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                    <img src={require('../../ISO-Mark.png')} alt="ISO 9001 Certified" style={{ width: '100px', height: '100px' }} />
                                    <span>ISO 9001 Certified</span>
                                </div>
                            </div>
                        </div>

                        <div className="trillion-about-features">
                            <div className="trillion-about-feature-item">
                                <div className="trillion-feature-icon">
                                    <FaCheckCircle />
                                </div>
                                <div className="trillion-feature-content">
                                    <h3>Trusted Research Services</h3>
                                    <p>Professional guidance backed by years of market experience</p>
                                </div>
                            </div>
                            <div className="trillion-about-feature-item">
                                <div className="trillion-feature-icon">
                                    <FaChartLine />
                                </div>
                                <div className="trillion-feature-content">
                                    <h3>Accurate Market Research</h3>
                                    <p>In-depth analysis and comprehensive market reports</p>
                                </div>
                            </div>
                            
                        </div>
                    </div>

                    <div className="trillion-about-sidebar">
                        <div className="trillion-about-contact-card">
                            <div className="trillion-contact-header">
                                <h3>Contact Information</h3>
                                <div className="trillion-contact-divider"></div>
                            </div>
                            <div className="trillion-contact-list">
                                <div className="trillion-contact-item">
                                    <FaMapMarkerAlt />
                                    <div className="trillion-contact-details">
                                        <span className="trillion-contact-label">Address</span>
                                        <span className="trillion-contact-text">200 Sector A Suryadev Nagar, Indore, Madhya Pradesh, 452012</span>
                                    </div>
                                </div>
                                <div className="trillion-contact-item">
                                    <FaPhone />
                                    <div className="trillion-contact-details">
                                        <span className="trillion-contact-label">Phone</span>
                                        <span className="trillion-contact-text">+91 9977555378</span>
                                    </div>
                                </div>
                                <div className="trillion-contact-item">
                                    <FaGlobe />
                                    <div className="trillion-contact-details">
                                        <span className="trillion-contact-label">Website</span>
                                        <span className="trillion-contact-text">trillionstockresearch.com</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="trillion-about-cta">
                            <div className="trillion-cta-content">
                                <div className="trillion-cta-header">
                                    <h3>Ready to Start Investing?</h3>
                                    <div className="trillion-cta-divider"></div>
                                </div>
                                <p>Maximize your market potential with Trillion Stock Research – Your Partner in Smart Investing! 🚀</p>
                                <div className="trillion-cta-button-wrapper">
                                    <button className="trillion-cta-button">
                                        <span>Get Started</span>
                                        <FaArrowRight />
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="trillion-about-disclosure">
                            <div className="trillion-disclosure-content">
                                <div className="trillion-disclosure-header">
                                    <h3>Regulatory Compliance</h3>
                                    <div className="trillion-disclosure-divider"></div>
                                </div>
                                <p>We are committed to transparency and regulatory compliance. View our SEBI disclosure for complete information about our services and regulatory status.</p>
                                <div className="trillion-disclosure-link-wrapper">
                                    <a href="/disclosure" className="trillion-disclosure-link">
                                        <span>View SEBI Disclosure</span>
                                        <FaExternalLinkAlt />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Aboutus